module.exports = __webpack_public_path__ + "img/8b8867f2061131a86d37019337cb531e.svg";